<template>
    <div class="modal fade" id="viewPrintDimandProbeshnoryNote">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printDimandProbeshnoryNote()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printDimandProbeshnoryNote">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <table class="table table-condensed">
                        <thead>
                          <td width="18%"><img :src="logo" height="90" width="100%"></td>
                          <td class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small><br><br><br><strong>डिमांड प्रामिसरी नोट <br>(Demand Promissory Note)</strong></h4></td>
                          <td class="text-right" width="20%">
                            <div v-if="seeRecord.member_loan_plan">
                              <barcode v-bind:value="seeRecord.member_loan_plan.applicationNo" height="45" width="1">
                                Show this if the rendering fails.
                              </barcode>
                            </div>
                          </td>
                        </thead>
                      </table>
                      <!-- <hr width="100%" style="height:5px;border-width:0;color:black;background-color:black"> -->
                      <div>
                        <strong>राशि : ₹ {{planAmt(seeRecord)}}</strong><br>
                            <big v-if="seeRecord.member_id" class="text-justify">
                              {{getCompanyRecord.companyName}} मैं श्री <strong>{{ seeRecord.member.name }}</strong> c/o  <strong v-if="mem.gender == 'Male'">{{mem.fatherName}}</strong><strong v-else>{{mem.spouseName}}</strong> निवासी <b>{{mem.address}}</b> जिला <b>{{mem.district}}</b> <b v-if="mem.state">राज्य {{mem.state.name}},</b> <b> {{mem.pin}}</b> का मूल निवासी हूँ, {{getCompanyRecord.companyName}} द्वारा मांगे जाने पर मेरे द्वारा प्राप्त की गई ऋण राशि रुपए <strong> ₹ {{planAmt(seeRecord)}}
                              </strong> को 
                              मैं अपने ऋण चुकौती की अनुसूची के अनुसार ईएमआई किस्तों का भुगतान करने का वादा करता हूं, 
                              जिसे पहले ऋण आवेदन पत्र में मेरे द्वारा जांचा और हस्ताक्षरित किया गया था।
                              <!-- <b><span v-if="pl.rateOfInterest">{{pl.rateOfInterest}}</span><span v-else>__</span>%</b>
                              <b>22.7%</b>
                               वार्षिक <span v-if="pl.typeOfInterest === 'reduced'">घटती </span> ब्याज की दर से तुरंत जमा करा दूंगा / दूंगी -->
                            </big>
                            <br><br>
                          <!-- <strong>Amount : ₹ <i v-if="pl.planType === 'normalReduced' || pl.planType === 'special'">{{ showPlanAmtReduced(pl) }}</i> -->
                          <strong>Amount : ₹ {{planAmt(seeRecord)}}</strong><br>
                            <big v-if="seeRecord.member_id" class="text-justify">
                              This is to certify that I, <b>{{ seeRecord.member.name }}</b> C/O <strong v-if="mem.gender == 'Male'">{{mem.fatherName}}</strong><strong v-else>{{mem.spouseName}}</strong> , resident at <b>{{mem.address}}</b> District - <b>{{mem.district}}</b>, State - <b v-if="mem.state">{{mem.state.name}}</b> 
                              has taken a loan of amount Rs. {{planAmt(seeRecord)}} from {{getCompanyRecord.companyName}} .
                              <!-- at 
                              <b><span v-if="pl.rateOfInterest > 0">{{pl.rateOfInterest}}</span><span v-else>__</span>%</b> -->
                              <!-- <b>22.7%</b> 
                               interest rate. -->

                              I hereby promise to pay the EMI instalments as per the schedule of my loan repayment that was previously checked and signed by me in the Loan Application Form.
                            </big>
                            <br>
                            <strong>Date: {{seeRecord.disbursementDate | myDate}}</strong>
                      </div><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
                      <p><table class="table">
                          <thead>
                            <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                            <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                            <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                          </thead>
                        </table>
                      </p>
                      
                      
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    
</template>
<script>
import VueBarcode from 'vue-barcode'
export default {
  name: 'PropsTesting',
  methods: {
    planAmt (row) {
      var fpi = 0
      var gstAmt = 0
      var pln = JSON.parse(row.plan)
      if (pln.planType !== 'normal') {
        if (pln.fileChargeIncludeAmt === 'true') {
          fpi += row.fileCharge ? row.fileCharge : parseInt(pln.fileCharge)
        }
        if (pln.processingFeeIncludeAmt === 'true') {
          fpi += row.processingFee ? row.processingFee : parseInt(pln.processingFee)
        }
        if (pln.insuranceFeeIncludeAmt === 'true') {
          fpi += row.insuranceFee ? row.insuranceFee : parseInt(pln.insuranceFee)
        }
        if (pln.includeGst === 'true') {
          gstAmt = fpi * 18 / 100
          fpi += parseInt(gstAmt)
        }
        return row.loanAmount ? row.loanAmount + fpi : pln.amount + fpi
      } else {
        return row.loanAmount ? row.loanAmount : pln.amount
      }
    },
    showPlanAmtNormal (pl) {
      // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.amount * pl.processingFee) / 100
      if (this.seeRecord.loanAmount) {
        return this.seeRecord.loanAmount
      } else {
        return pl.amount
      }
    },
    showPlanAmtReduced (pl) {
      var fpi = 0
      var gstAmt = 0
      if (pl.fileChargeIncludeAmt === 'true') {
        fpi += this.seeRecord.fileCharge ? this.seeRecord.fileCharge : parseInt(pl.fileCharge)
      }
      if (pl.processingFeeIncludeAmt === 'true') {
        fpi += this.seeRecord.processingFee ? this.seeRecord.processingFee : parseInt(pl.processingFee)
      }
      if (pl.insuranceFeeIncludeAmt === 'true') {
        fpi += this.seeRecord.insuranceFee ? this.seeRecord.insuranceFee : parseInt(pl.insuranceFee)
      }
      if (pl.includeGst === 'true') {
        gstAmt = fpi * 18 / 100
        fpi += parseInt(gstAmt)
      }
      return this.seeRecord.loanAmount ? this.seeRecord.loanAmount + fpi : parseInt(pl.amount) + fpi
      // if (this.seeRecord.loanAmount) {
      //   return this.seeRecord.loanAmount + (pl.fileChargeIncludeAmt === 'true' ? this.seeRecord.fileCharge : 0) + (pl.processingFeeIncludeAmt === 'true' ? this.seeRecord.processingFee : 0)
      // } else {
      //   if (pl.fileChargeIncludeAmt === 'false' && pl.processingFeeIncludeAmt === 'false') {
      //     return parseInt(pl.amount)
      //   } else if (pl.fileChargeIncludeAmt === 'false' && pl.processingFeeIncludeAmt === 'true') {
      //     return parseInt(pl.amount) + parseInt(pl.processingFee)
      //   } else if (pl.fileChargeIncludeAmt === 'true' && pl.processingFeeIncludeAmt === 'false') {
      //     return parseInt(pl.amount) + parseInt(pl.fileCharge)
      //   } else {
      //     return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
      //   }
      //   // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
      // }
      // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
    },
    printDimandProbeshnoryNote () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('printDimandProbeshnoryNote').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    }
  },
  components: {
    'barcode': VueBarcode
  },
  props: {
    seeRecord: {},
    memberDetail: {},
    mem: {},
    pl: {},
    logo: '',
    getCompanyRecord: {}
  }
}
</script>



// WEBPACK FOOTER //
// DemandProbeshnaryNote.vue?4682f9d2